import { render } from "./TelegramIntegration.vue?vue&type=template&id=7e7ff216"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/TelegramIntegration.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e7ff216"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e7ff216', __exports__)) {
    api.reload('7e7ff216', __exports__)
  }
  
  module.hot.accept("./TelegramIntegration.vue?vue&type=template&id=7e7ff216", () => {
    api.rerender('7e7ff216', render)
  })

}


export default __exports__